"use client"
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap"; 
import Link from "next/link";
import { usePathname } from "next/navigation";
import { formatDurations } from '../../lib/function';
import { FaArrowRight } from "react-icons/fa";

// Define TypeScript interfaces for the data structure
interface PriceOption {
  value: number;
  label: string;
}

interface PackageData {
  title: string;
  priceOptions: PriceOption[];
  features: string[];
  configureUrl : string;
}

interface PricingData {
  [country: string]: PackageData[];
}


type DurationPlan = {
  type: string;
  currency: string;
  period: number;
  price: number;
  actuall_price: number;
  desc: string;
  discount: number;
};

type DurationMap = {
  [key: string]: DurationPlan;
};


const HostingPricingResell = () => {
  const [pricingData, setPricingData] = useState<PricingData | null>(null);
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const pathname = usePathname();
  const rawSlug = pathname?.split("/").pop() || "";
  const country = pathname?.split("-").pop() || "";
  
  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        const response = await fetch('/api/plan', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            rawSlug
          }),
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        const mockPackages: Record<string, PackageData[]> = {};
        mockPackages[country] = result.data.slice(0, 20).map((item: {id: number, name: string, description:string, duration:DurationMap}): PackageData => ({
            title: item.name,
            priceOptions: formatDurations(item.duration),
            features: item.description.split(/\r?\n/)
            .filter(line => line.includes(':'))
            .map(line => {
              const [key, ...rest] = line.split(':');
              return key.trim() + ' - ' +rest.join(':').trim()
              ;
            }),
            configureUrl: `${process.env.NEXT_PUBLIC_API_BASE_URL}/cart.php?a=add&pid=${item.id}&billingcycle=${item.duration.monthly.type}`
          }));

        const data: PricingData = mockPackages;
        setPricingData(data);
        setSelectedCountry(country);
      } catch (error) {
        console.error("There was an error fetching the data: ", error);
      }
    };

    fetchPricingData();
  }, [rawSlug, country]);

  if (!pricingData || !pathname) return <div>Loading...</div>;
 
  return (
    <div className="custMargin" id="pricing">
      <div className="container">
        <div className="text-center my-4">
          <div className="mt-5">
            <h1 className="textHad display-5 fw-bold">
            <span className="text-capitalize">{pathname.replace(/-/g, " ").replace("/", " ").replace(country,'')} Plans</span>
            </h1>
          </div>
        </div>

        {/* Button navigation for countries */}
        <div className="d-flex justify-content-center mb-4">

            <Link
              href="/linux-reseller-hosting-usa"
              className={`mx-2 text-decoration-none custLink ${country.toLowerCase() === 'usa' ? 'custLink-default' : ''}`}
            >
              USA
            </Link>
          
            <Link href="/linux-reseller-hosting-netherlands "
              className={`mx-2 text-decoration-none custLink ${country.toLowerCase() === 'netherlands' ? 'custLink-default' : ''}`}
            >
              Netherlands
            </Link> 
        </div>

        {/* Display content based on selected country */}
        {selectedCountry && (
          <div className="row d-flex justify-content-center">
            {pricingData[selectedCountry].map((packageData, index) => {
              const minValue = Math.min(...packageData.priceOptions.map(o => o.value));
              return (
              <div className="col-lg-3 col-md-6 col-12" key={index}>
                <div className="card-body h-100 hostFeat hvr-float-shadow d-block">
                  <h2 className="textHad fs-5 fw-bold h4 text-center">
                    {packageData.title}
                  </h2>
                  <Form.Select size="lg" className="my-4" defaultValue={minValue}>
                    {packageData.priceOptions.map((option, idx) => (
                      <option key={idx} value={option.value}>
                        {process.env.NEXT_PUBLIC_CURRENCY_SYMBOL} {option.label}
                      </option>
                    ))}
                  </Form.Select>
                  <div className="d-grid gap-2 mt-4 mb-2">
                    {/* <Link href={packageData.configureUrl} className="btn btn-outline-primary my-3 w-100">
                      Add to Cart
                    </Link> */}

<Link href={packageData.configureUrl}> 
                  <Button className="orangeBtn fw-semibold w-100"  size="lg">
                  Add to Cart <FaArrowRight className="" />
                </Button> 
                </Link>
                  </div>
                  <p className="textPara small text-center">
                    Auto-renews at regular rate
                  </p>
                  <div className="my-3 featList">
                    <h5 className="textHad fw-bold fs-5">Features</h5>
                    <ul className="list-unstyled custList">
                      {packageData.features.map((feature, index) => (
                        <li key={index}>
                          <span className="text-success">✔</span> <span className="textHad fw-semibold">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )})}
          </div>
        )}
      </div>
    </div>
  );
};

export default HostingPricingResell;
